export const initialState = {
  isLoading: 0,
  showAuthSuccess: false,
  isDashboardLoaded: false,
  modal: {
    showModal: false,
    title: '',
    content: '',
    link: null,
    options: {},
  },
  info: {
    showInfo: false,
  },
  authError: null,
};
